module.exports = "/complete_profile-dbc540f718942124a36d46d4ce7ef543.svg";